import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { UserSettingsType } from 'data/Auth/types'
import { UpdateEmailResponseType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { saveSettings, updateEmail } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import { actions as A } from './slice'

const setSelectedCurrency = function* (action) {
  const localCurrency = yield select(selectors.auth.getLocalCurrency)

  const prevCurrencySetting: Partial<UserSettingsType> = {
    localCurrency
  }

  const settings: Partial<UserSettingsType> = {
    localCurrency: action.payload
  }

  if (localCurrency === action.payload) return

  const response = yield call(saveSettings, settings)
  if (response.ok) {
    yield put(actions.auth.getUser())

    yield put(actions.auth.setUserSettings(prevCurrencySetting, settings))
    yield call(notifySuccess, 'OK_SAVE_PREFERENCES')
  }
}

const setShowNotifications = function* (action) {
  const settings: Partial<UserSettingsType> = {
    showNotifications: action.payload
  }

  const response = yield call(saveSettings, settings)
  if (response.ok) {
    yield put(actions.auth.getUser())

    yield call(notifySuccess, 'OK_SAVE_PREFERENCES')
  }
}

const setNewUserEmail = function* (action) {
  const email: void | string = yield select(selectors.auth.getEmail)

  yield put(
    actions.form.initialize(formName.CHANGE_EMAIL, {
      loading: true,
      newEmail: action.payload,
      oldEmail: email || ''
    })
  )

  const data: Response<UpdateEmailResponseType> = yield call(updateEmail, {
    email: action.payload
  })

  yield put(actions.form.change(formName.CHANGE_EMAIL, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.app.showModal('CHANGE_EMAIL'))

  yield put(
    actions.form.change(formName.CHANGE_EMAIL, 'oldEmailVerificationId', data.response.ids[0])
  )
  yield put(
    actions.form.change(formName.CHANGE_EMAIL, 'newEmailVerificationId', data.response.ids[1])
  )
  yield put(actions.auth.getUser())
}

export default function* accountMain() {
  yield takeEvery(A.setSelectedCurrency.type, setSelectedCurrency)
  yield takeEvery(A.setShowNotifications.type, setShowNotifications)
  yield takeEvery(A.setNewUserEmail.type, setNewUserEmail)
}
